"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PasswordRequirements = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

require("./PasswordRequirements.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    // had to include the !important because they were not overriding the default mui class styling
    iconGrey: {
      color: theme.palette.grey['400']
    },
    iconGreen: {
      color: '#41AD49'
    },
    progressRoot: {
      backgroundColor: theme.palette.grey['300'],
      width: '50%'
    },
    progressRed: {
      backgroundColor: theme.palette.error.main
    },
    progressYellow: {
      backgroundColor: theme.palette.common.warn
    },
    progressGreen: {
      backgroundColor: '#41AD49'
    }
  };
};

var PasswordRequirements = /*#__PURE__*/function (_React$Component) {
  _inherits(PasswordRequirements, _React$Component);

  var _super = _createSuper(PasswordRequirements);

  function PasswordRequirements() {
    _classCallCheck(this, PasswordRequirements);

    return _super.apply(this, arguments);
  }

  _createClass(PasswordRequirements, [{
    key: "passwordCheck",
    value: function passwordCheck(password, pwdReqs) {
      var _this = this;

      return pwdReqs.every(function (req) {
        return _this.requirementCheck(password, req);
      });
    }
  }, {
    key: "progressBarCompose",
    value: function progressBarCompose() {
      var _this2 = this;

      var progressClass;
      var progress = 0;
      var _this$props = this.props,
          requirements = _this$props.passwordRequirements,
          classes = _this$props.classes;
      requirements.forEach(function (req) {
        if (_this2.requirementCheck(_this2.props.password, req)) {
          progress = progress + 100 / requirements.length;
        }
      });

      if (progress >= 0 && progress <= 40) {
        progressClass = classes.progressRed;
      } else if (progress >= 50 && progress <= 90) {
        progressClass = classes.progressYellow;
      } else {
        progressClass = classes.progressGreen;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "PasswordRequirements_progressBarContainer"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Weak"), /*#__PURE__*/_react["default"].createElement(_material.LinearProgress, {
        variant: "determinate",
        value: progress,
        classes: {
          root: classes.progressRoot,
          bar: progressClass
        }
      }), /*#__PURE__*/_react["default"].createElement("span", null, "Strong"));
    }
  }, {
    key: "requirementCheck",
    value: function requirementCheck(password, req) {
      return password.search(req.PasswordRegularExpression) === 0;
    }
  }, {
    key: "requirementsCompose",
    value: function requirementsCompose() {
      var _this3 = this;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          passwordRequirements = _this$props2.passwordRequirements,
          password = _this$props2.password;
      var requirements = passwordRequirements.map(function (req) {
        var iconClass = classes.iconGrey;

        if (_this3.requirementCheck(password, req)) {
          iconClass = classes.iconGreen;
        }

        return /*#__PURE__*/_react["default"].createElement("div", {
          key: req.PasswordRequirementId,
          className: "PasswordRequirements_requirement"
        }, /*#__PURE__*/_react["default"].createElement(_material.Icon, {
          classes: {
            colorPrimary: iconClass
          },
          sx: {
            fontSize: '16px',
            marginRight: '3px'
          },
          color: "primary"
        }, "check_circle"), /*#__PURE__*/_react["default"].createElement("span", null, req.RequirementDescription));
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, requirements);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          password = _this$props3.password,
          passwordRequirements = _this$props3.passwordRequirements,
          onPasswordCheck = _this$props3.onPasswordCheck;

      if (password !== prevProps.password) {
        if (this.passwordCheck(password, passwordRequirements)) {
          onPasswordCheck(true);
        } else {
          onPasswordCheck(false);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "PasswordRequirements_container"
      }, this.progressBarCompose(), /*#__PURE__*/_react["default"].createElement("div", {
        className: "PasswordRequirements_requirementsContainer"
      }, this.requirementsCompose()));
    }
  }]);

  return PasswordRequirements;
}(_react["default"].Component);

exports.PasswordRequirements = PasswordRequirements;

_defineProperty(PasswordRequirements, "propTypes", {
  passwordRequirements: _propTypes["default"].array.isRequired,
  password: _propTypes["default"].string.isRequired,
  onPasswordCheck: _propTypes["default"].func.isRequired,
  classes: _propTypes["default"].object.isRequired
});

_defineProperty(PasswordRequirements, "defaultProps", {
  passwordRequirements: []
});

var _default = (0, _styles.withStyles)(styles)(PasswordRequirements);

exports["default"] = _default;